import { useQueryClient } from '@tanstack/react-query'
import type { ResultOf } from '@purposity/sdk'
import { useQueryWithAuth } from '@lib/Auth/clerk-utils'
import { stories } from '../model/query-keys'

export function useStory(storyId: number) {
  const queryClient = useQueryClient()

  const query = useQueryWithAuth({
    ...stories.detail(storyId),
    keepPreviousData: true,
    select: (data) => data?.story,
    initialData: () => {
      type Stories = ResultOf<ResultOf<typeof stories.all>['queryFn']>
      type Story = ResultOf<ResultOf<typeof stories.detail>['queryFn']>

      // Get the query object
      const state = queryClient.getQueryState<Stories>(stories.detail._def)

      // If the query exists and has data that is no older than 7 days, return the individual item
      if (
        state &&
        Array.isArray(state.data?.stories) &&
        Date.now() - state.dataUpdatedAt <= 1000 * 60 * 60 * 24 * 7 // 7 days
      ) {
        //
        return state.data?.stories.find((i) => i.id === storyId) as Story
      }
      // Otherwise, return undefined and let it fetch
      return undefined
    },
    enabled: !!storyId,
  })
  return query.data
}
